(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pml-homepage-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pml-homepage-section')) {
class PMLHomepage extends HTMLElement {
 connectedCallback(){this.frame=requestAnimationFrame(()=>this.init());}
 disconnectedCallback(){cancelAnimationFrame(this.frame);}
 init(){if(this.initialized)return;this.initialized=true;const root=this;
 const engineHeading=root.querySelector('[data-engine-heading]');
 if(engineHeading){const engineButton=[...root.querySelectorAll('.pml-actions a')].find(a=>a.getAttribute('href')==='#'+engineHeading.id);if(engineButton)engineButton.addEventListener('click',event=>{if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();engineHeading.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});});}

 const buildButton=[...root.querySelectorAll('.pml-actions a')].find(a=>(a.getAttribute('href')||'').startsWith('#inside-'));
 if(buildButton){const buildTarget=root.querySelector(buildButton.getAttribute('href'));if(buildTarget)buildButton.addEventListener('click',event=>{if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();buildTarget.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});});}

 const video=root.querySelector('video');if(video){if(matchMedia('(max-width:700px)').matches&&root.dataset.mobileVideo)video.src=root.dataset.mobileVideo;if(matchMedia('(prefers-reduced-motion:reduce)').matches){video.autoplay=false;video.pause();}}
 const filters=[...root.querySelectorAll('[data-filter]')];function filter(f){filters.forEach(b=>{const active=b.dataset.filter===f;b.classList.toggle('pml-active',active);b.setAttribute('aria-pressed',String(active))});root.querySelectorAll('[data-fuel]').forEach(c=>c.hidden=f!=='all'&&c.dataset.fuel!==f)}filters.forEach(b=>b.onclick=()=>filter(b.dataset.filter));
 const points=[...root.querySelectorAll('[data-point]')];
 points.forEach((button,index)=>{button.querySelector('.pml-hotspot-number').textContent=String(index+1)});
 const detail=root.querySelector('.pml-detail');
 if(detail){['.pml-detail-number','[data-ref="detail-title"]','[data-ref="detail-copy"]','.pml-detail-rule','.pml-detail-controls'].forEach(selector=>{const node=detail.querySelector(selector);if(node)node.hidden=points.length===0});const controls=detail.querySelector('.pml-detail-controls');if(controls)controls.hidden=points.length<2;}
 const caption=root.querySelector('.pml-stage-caption');if(caption)caption.hidden=points.length===0;
 let current=0;function showPoint(n){if(!points.length)return;current=(n+points.length)%points.length;const b=points[current];root.querySelector('[data-ref="detail-title"]').textContent=b.dataset.title;root.querySelector('[data-ref="detail-copy"]').textContent=b.dataset.copy;root.querySelector('.pml-detail-number').textContent=String(current+1).padStart(2,'0')+' / '+String(points.length).padStart(2,'0');points.forEach(x=>{x.classList.toggle('pml-selected',x===b);x.setAttribute('aria-pressed',String(x===b))});}points.forEach((b,i)=>b.onclick=()=>showPoint(i));root.querySelectorAll('[data-step]').forEach(b=>b.onclick=()=>showPoint(current+Number(b.dataset.step)));showPoint(0);
 const series=[['DAILY DRIVING & RELIABILITY','Remanufactured with attention to common failure points. Review the platform-specific build details with our team.','Better Than OEM','better-than-oem'],['WORK TRUCKS & TOWING','Tell us what you tow and how you use your truck. Explore the Power & Pull series and discuss the supporting setup for your application.','Power & Pull','power-pull'],['PERFORMANCE-FOCUSED BUILDS','Start with your performance goals and vehicle setup. Explore the available build options with our team before choosing your combination.','Power & Performance','power-performance']];root.querySelectorAll('[data-series]').forEach(b=>b.onclick=()=>{const s=series[Number(b.dataset.series)];root.querySelectorAll('[data-series]').forEach(x=>{x.classList.toggle('pml-active',x===b);x.setAttribute('aria-pressed',String(x===b))});root.querySelector('[data-ref="series-use"]').textContent=s[0];root.querySelector('[data-ref="series-copy"]').textContent=s[1];root.querySelector('[data-ref="series-link"]').textContent='Explore '+s[2];root.querySelector('[data-ref="series-link"]').href='/pages/'+s[3];});


 root.addEventListener('shopify:block:select',e=>{const card=e.target.closest('[data-pml-engine]');if(card){filter('all');card.scrollIntoView({block:'center',behavior:'auto'});}});
 }
}
customElements.define('pml-homepage-section',PMLHomepage);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
